export default __webpack_public_path__ + "static/media/icon-permission.1c9e9d2a.svg";